(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["subcollections"]) return;
  try {
    
  if (!customElements.get('ruru-collection-chips')) {
    customElements.define('ruru-collection-chips', class extends HTMLElement {
      connectedCallback() {
        this.list = this.querySelector('.ruru-collection-chips__scroller');
        this.toggle = this.querySelector('.ruru-collection-chips__toggle');
        this.moreLabel = this.querySelector('[data-chips-more]');
        this.lessLabel = this.querySelector('[data-chips-less]');
        this.mobileQuery = window.matchMedia('(max-width: 749px)');
        this.updateToggle = this.updateToggle.bind(this);

        this.toggle?.addEventListener('click', () => {
          const expanded = this.toggle.getAttribute('aria-expanded') === 'true';
          this.toggle.setAttribute('aria-expanded', String(!expanded));
          this.classList.toggle('is-expanded', !expanded);
          this.moreLabel.hidden = !expanded;
          this.lessLabel.hidden = expanded;
        });

        requestAnimationFrame(this.updateToggle);
        this.resizeObserver = new ResizeObserver(this.updateToggle);
        this.resizeObserver.observe(this);
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
      }

      updateToggle() {
        if (!this.list || !this.toggle) return;
        if (!this.mobileQuery.matches) {
          this.toggle.hidden = true;
          return;
        }

        const wasExpanded = this.classList.contains('is-expanded');
        if (wasExpanded) this.classList.remove('is-expanded');
        const hasMore = this.list.scrollHeight > this.list.clientHeight + 2;
        if (wasExpanded) this.classList.add('is-expanded');
        this.toggle.hidden = !hasMore;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
